module.exports = __webpack_public_path__ + "data-table.b0aebd744ce7adb780a9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-datatable/release/assets/fonts/data-table.svg
// module id = 563
// module chunks = 15